import type { AdvisorRegion } from './types';

export const DEFAULT_ADVISOR_COUNTRY = 'Portugal';

export const regionMatchesCountry = (
  region: AdvisorRegion,
  country: string
): boolean =>
  region.countries.some(
    (entry) => entry.toLowerCase() === country.toLowerCase()
  );

export const regionsForCountry = (
  regions: AdvisorRegion[],
  country: string
): AdvisorRegion[] =>
  regions.filter((region) => regionMatchesCountry(region, country));

export const countriesFromRegions = (regions: AdvisorRegion[]): string[] => {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const region of regions) {
    for (const entry of region.countries) {
      const label = entry.trim();
      if (!label) continue;
      const fold = label.toLowerCase();
      if (seen.has(fold)) continue;
      seen.add(fold);
      out.push(label);
    }
  }
  return out.sort((a, b) => a.localeCompare(b));
};

export const resolveAdvisorCountry = (regions: AdvisorRegion[]): string => {
  if (
    regions.some((region) =>
      regionMatchesCountry(region, DEFAULT_ADVISOR_COUNTRY)
    )
  ) {
    return DEFAULT_ADVISOR_COUNTRY;
  }
  return regions[0]?.countries[0] ?? DEFAULT_ADVISOR_COUNTRY;
};

export const resolveSelectedCountry = (
  requested: string | null | undefined,
  countries: string[]
): string => {
  if (requested) {
    const match = countries.find(
      (entry) => entry.toLowerCase() === requested.toLowerCase()
    );
    if (match) return match;
  }
  const portugal = countries.find(
    (entry) => entry.toLowerCase() === DEFAULT_ADVISOR_COUNTRY.toLowerCase()
  );
  return portugal ?? countries[0] ?? requested ?? DEFAULT_ADVISOR_COUNTRY;
};
